// extracted by mini-css-extract-plugin
module.exports = {"link":"WishListLink__link","disabled":"WishListLink__disabled"};